import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Post Cards - INGAZ Print";

function Postcards() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          {/* Product Details Section */}
          <section className="product-details-section">
            <div className="product-container">
              {/* Left: Product Image Gallery */}
              <ProductGallery alt="Post Cards" images={[asset('assets/postcard_mockup_1769341055587.png'), asset('assets/postcard_stack_designed_1769363440340.png'), asset('assets/postcard_fan_designed_1769363455795.png'), asset('assets/postcard_flat_designed_1769363470562.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Postcards" data-ar="البطاقات البريدية">Postcards</h1>
                <p className="product-description" data-en="Elegant post cards on premium paper stocks." data-ar="بطاقات بريدية أنيقة على ورق فاخر.">Elegant post cards on premium paper stocks.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Cost-effective direct mail marketing" data-ar="تسويق بريدي مباشر منخفض التكلفة">
                      Cost-effective direct mail marketing</li>
                    <li data-en="Tangible brand impact" data-ar="تأثير ملموس للعلامة التجارية">
                      Tangible brand impact</li>
                    <li data-en="Versatile for various messaging" data-ar="متعدد الاستخدامات لرسائل مختلفة">
                      Versatile for various messaging</li>
                    <li data-en="Standard sizes for easy mailing" data-ar="أحجام قياسية لسهولة المراسلة">
                      Standard sizes for easy mailing</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Promotions" data-ar="العروض الترويجية">Promotions</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/calendar.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Save Dates" data-ar="تذكير المواعيد">Save Dates</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Coupons" data-ar="كوبونات">Coupons</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Real Estate" data-ar="العقارات">Real Estate</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          {/* Configuration Section */}
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Post Cards" data-ar="قم بتكوين البطاقات البريدية الخاصة بك">Configure Your Post Cards</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="A6" data-dims="105x148">A6<br /><span>105x148</span></div>
                    <div className="size-option" data-size="Custom" data-dims="Custom"><span data-en="Custom" data-ar="مخصص">Custom</span><br /><span data-en="L × W" data-ar="الطول × العرض">L × W</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type" data-ar="نوع الورق">Paper Type</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="couche-350" data-en="Couche 350 gsm" data-ar="كوشيه 350 جم">Couche 350 gsm</option>
                      <option value="couche-300" data-en="Couche 300 gsm" data-ar="كوشيه 300 جم">Couche 300 gsm</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printed Sides */}
                <div className="config-group">
                  <label data-en="Printing Sides" data-ar="الجوانب المطبوعة">Printing Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single" data-en="One side" data-ar="جانب واحد">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>One side</span>
                    </div>
                    <div className="side-option" data-sides="double" data-en="Double sides" data-ar="جانبان">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Double sides</span>
                    </div>
                  </div>
                </div>
                {/* Lamination */}
                <div className="config-group">
                  <label data-en="Lamination" data-ar="التغليف">Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="matt-one" />
                      <span data-en="Matt Cellophane [One side]" data-ar="سيلوفان غير لامع [جانب واحد]">Matt Cellophane [One side]</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="matt-both" />
                      <span data-en="Matt Cellophane [Both sides]" data-ar="سيلوفان غير لامع [جانبان]">Matt Cellophane [Both sides]</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="gloss-one" />
                      <span data-en="Gloss Cellophane [One side]" data-ar="سيلوفان لامع [جانب واحد]">Gloss Cellophane [One side]</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="gloss-both" />
                      <span data-en="Gloss Cellophane [Both sides]" data-ar="سيلوفان لامع [جانبان]">Gloss Cellophane [Both sides]</span>
                    </label>
                  </div>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                <NotesField />
                {/* Upload Design Files */}
                <div className="config-group">
                  <label data-en="Upload Design Files" data-ar="رفع ملفات التصميم">Upload Design Files</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here
                        or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS,
                        PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize">A6</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Paper:" data-ar="الورق:">Paper:</span>
                    <span className="summary-value" id="summaryPaper">Couche 350 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Color:" data-ar="اللون:">Color:</span>
                    <span className="summary-value" id="summaryColor">Colored</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Sides:" data-ar="جوانب الطباعة:">Sides:</span>
                    <span className="summary-value" id="summarySides">Double Sides</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Lamination:" data-ar="التغليف:">Lamination:</span>
                    <span className="summary-value" id="summaryLamination">Matt Cellophane</span>
                  </div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time" data-en="1-2 business days" data-ar="1-2 أيام عمل">1-2 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item" data-en="✓ Free design review" data-ar="✓ مراجعة تصميم مجانية">✓ Free design
                    review</div>
                  <div className="guarantee-item" data-en="✓ Quality guarantee" data-ar="✓ ضمان الجودة">✓ Quality guarantee</div>
                  <div className="guarantee-item" data-en="✓ Fast turnaround" data-ar="✓ تسليم سريع">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image1.webp')} alt="Business Cards" />
                  </div>
                  <h3 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h3>
                  <p data-en="Professional business cards" data-ar="بطاقات عمل احترافية">Professional business cards</p>
                  <a href="/business-cards" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus" />
                  </div>
                  <h3 data-en="Menus" data-ar="القوائم">Menus</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default Postcards;
